import { createAsyncThunk } from '@reduxjs/toolkit'
import apiClient from '../../../services/axois'
import { toast } from 'react-toastify'

export const getAllUser = createAsyncThunk('user/getAllUsers', async () => {
  try {
    let url = '/users'

    const response = await apiClient.get(url)
    return response.data.result
  } catch (error) {
    console.error('builder function error:', error)
    throw error
  }
})

export const getUser = createAsyncThunk('user/getUser', async (userId) => {
  try {
    const url = `/user/${userId}`
    const response = await apiClient.get(url)
    return response.data.result
  } catch (error) {
    console.error('builder function error:', error)
    throw error
  }
})

export const createUser = createAsyncThunk('user/createUser', async ({ data, navigate }, { dispatch }) => {
  try {
    const url = `/user/create`
    const response = await apiClient.post(url, data)
    dispatch(getAllUser())
    if (response.status) {
      toast.success(response.data.message, {
        className: 'custom-toast-success',
        progressStyle: { background: '#ffffff' },
      })
      navigate('/user-management')
    }
  } catch (error) {
    console.error('builder function error:', error)
    toast.error(error.response.data.message, {
      className: 'custom-toast-error',
      progressStyle: { background: '#C53C43' },
    })
    throw error
  }
})

export const editUser = createAsyncThunk('user/editUser', async ({ editObj, id, navigate }, { dispatch }) => {
  try {
    const url = `/user/${id}/update`
    const response = await apiClient.put(url, editObj)
    dispatch(getAllUser())
    if (response.status) {
      toast.success(response.data.message, {
        className: 'custom-toast-success',
        progressStyle: { background: '#ffffff' },
      })
      navigate('/user-management')
    }
    return response.editObj
  } catch (error) {
    console.error('builder function error:', error)
    toast.error(error.response.data.message, {
      className: 'custom-toast-error',
      progressStyle: { background: '#C53C43' },
    })
    throw error
  }
})
